export class InMemoryStorage implements Storage {
  private keys: string[] = [];

  clear(): void {
    this.keys.forEach(key => {
      delete this[key];
    });
  }

  removeItem(key: string): void {
    delete this[key];
  }

  setItem(key: string, value: string): void {
    this[key] = value.toString();
  }

  getItem(key: string): string {
    return this[key];
  }

  key(index: number): string {
    return this.keys[index];
  }

  get length(): number {
    return this.keys.length;
  }
}
